const i18n = {
  'zh-CN': {
    therequestfailed: '请求失败',
    backMall: '导入',
    currentlist: '将为您导出当前列表的全部数据',
    currentFilter: '将为您导出当前筛选结果的全部数据',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteInformation: '确定删除信息吗?',
    successfullyDelete: '删除成功',
    selectedInformation: '确定删除所选信息吗?',
    templateIncorrect: '该按钮对应的模板配置有误，请联系系统管理员',
    placeSelectData: '请选择数据',
    importLimit: '导入数据上限',
    importTypeAll: '导入模式: 全部正确才导入',
    importAllDes: '例如: 上传的文件有100条数据,校验后,任意数据错误,则全部数据都不导入',
    importTypePartially: '导入模式: 部分正确就导入',
    importPartiallyDes: '例如: 上传的文件有100条数据,校验后,有20条正确数据,则成功导入20条'
  },
  'en': {
    therequestfailed: 'Request failed',
    backMall: 'Import',
    currentlist: 'All the data of the current list will be exported for you',
    currentFilter: 'All the data of the current filtered result will be exported for you',
    tip: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteInformation: 'Confirm to delete the information?',
    successfullyDelete: 'Deleted successfully',
    selectedInformation: '确定删除所选信息吗?',
    templateIncorrect: 'The template configuration corresponding to this button is incorrect, please contact the system administrator.',
    placeSelectData: '请选择数据en',
    importLimit: 'Import data limit',
    importTypeAll: 'The import mode: import only if everything is correct',
    importAllDes: 'For example, if there are 100 pieces of data in the uploaded file, and any data is wrong after verification, all data will not be imported',
    importTypePartially: 'Import mode: import partially correct',
    importPartiallyDes: 'For example, if there are 100 pieces of data in the uploaded file, 20 pieces of correct data will be imported successfully after verification'
  }
}
export default i18n